import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Tooltip, { StyledTooltip } from '../general/Tooltip'
import Flag from '../general/Flag'
import translate from '../../helper/translate'
import { desktop } from '../../styles/media'

const RegionOnlyFlag = ({ releaseEu, releaseNa, t }) => (
	<>
		{releaseNa && !releaseEu && (
			<StyledRegionOnlyFlag>
				<Tooltip title={t('general.releaseNaOnly')}>
					<Flag country="us" />
				</Tooltip>
			</StyledRegionOnlyFlag>
		)}

		{releaseEu && !releaseNa && (
			<StyledRegionOnlyFlag>
				<Tooltip title={t('general.releaseEuOnly')}>
					<Flag country="eu" />
				</Tooltip>
			</StyledRegionOnlyFlag>
		)}
	</>
)

RegionOnlyFlag.propTypes = {
	releaseEu: PropTypes.string,
	releaseNa: PropTypes.string,
	t: PropTypes.func.isRequired
}

RegionOnlyFlag.defaultProps = {
	releaseEu: null,
	releaseNa: null
}

export const StyledRegionOnlyFlag = styled.span`
	display: inline-block;
	height: 14px;
	margin-left: 0.5rem;

	img {
		vertical-align: baseline;
	}

	${StyledTooltip} {
		height: 14px;
	}
`

const enhance = translate('general')

export default enhance(RegionOnlyFlag)
